
import React from "react";

const FormGroup = ({ label, id, type = "text", placeholder, required, min }) => {
  if (type === "textarea") {
    return (
      <div className="mb-3">
        <label htmlFor={id} className="form-label">{label}</label>
        <textarea id={id} className="form-control" rows={3} placeholder={placeholder} required={required} />
      </div>
    );
  }
  return (
    <div className="mb-3">
      <label htmlFor={id} className="form-label">{label}</label>
      <input id={id} type={type} className="form-control" placeholder={placeholder} required={required} min={min} />
    </div>
  );
};

export default FormGroup;
